const css = `.l6NdQq__tooltip{width:fit-content}.l6NdQq__dqmTableName{word-break:break-word}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"tooltip":"l6NdQq__tooltip","dqmTableName":"l6NdQq__dqmTableName"};
